<template>
  <RadioGroup v-if="selector=='radio'" v-model="privateValue" @on-change="onChange">
    <Radio v-for="type in types" :label="type.key" :key="type.key">{{type.value}}</Radio>
  </RadioGroup>
  <Select v-else v-model="privateValue" clearable @on-change="onChange">
    <Option :value="type.key" v-for="type in types" :key="type.key">{{type.value}}</Option>
  </Select>
</template>
<script>
import * as enums from "../utils/enums.js";

export default {
  name: "EnumSelect",
  props: {
    type: {
      type: String,
      required: true
    },
    selector: {
      type: String,
      default: "radio"
    },
    value: {},
    except: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  model: {
    prop: "value",
    event: "onChange"
  },
  data() {
    return {
      types: [],
      privateValue: ""
    };
  },
  created() {
    this.privateValue = this.value.toString();
    this.types = enums[this.type]
      .getOptions()
      .filter(t => this.except.indexOf(t.key) < 0);
  },
  methods: {
    onChange() {
      this.$emit("onChange", this.privateValue);
    }
  },
  watch: {
    value() {
      if (!this.value) {
        this.privateValue = "";
        return;
      }
      this.privateValue = this.value.toString();
    }
  }
};
</script>
